import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import { fetchData, deleteData, activateData, updateData, SyncData, postData, DespatchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Tooltip } from '@mui/material';
import ArrowForward from '@mui/icons-material/ArrowForward';
import Select from 'react-select';
import { useParams, useHistory } from 'react-router-dom';
import Modal from '@mui/material/Modal';
import { FaHtml5, FaTimes } from 'react-icons/fa';
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import * as XLSX from 'xlsx';
import CircularProgress from '@mui/material/CircularProgress';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SearchIcon from '@mui/icons-material/Search';
import TablePagination from '@mui/material/TablePagination';
import TableFooter from '@mui/material/TableFooter';

function RouteWiseOutstandingReport() {
    const history = useHistory();
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [editedRouteSequenceNo, setEditedRouteSequenceNo] = useState(null);

    const [editItemId, setEditItemId] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);
    const [formData, setFormData] = useState();
    const [tripOptions, setTripOptions] = useState([]);
    const [selectedTrip, setSelectedTrip] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [tripDate, setTripDate] = useState('');
    const { isAuthenticated, companyId, userId, permissions, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');
    const [customerid, setcustomerid] = useState(false);
    const [showTable, setShowTable] = useState(false);

    const [selectedCustomerData, setSelectedCustomerData] = useState(null);  // Ensure initial state

    const [fromdate, setfromdate] = useState(new Date().toISOString().split('T')[0]);
    const [toDate, setToDate] = useState(new Date().toISOString().split('T')[0]);
    const [routeOptions, setRouteOptions] = useState([]);
    const [selectedRoute, setSelectedRoute] = useState(null);
    const [saledata, setSData] = useState(false);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
        }
    }, [isAuthenticated, companyId, token, logout]);

    useEffect(() => {
        fetchRouteTypes();
    }, []);

    const fetchRouteTypes = async () => {
        try {
            const response = await fetchData('RouteApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(route => ({
                    value: route.id,
                    label: route.name
                }));
                setRouteOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }

    };

    const [filteredData, setFilteredData] = useState([]);
    const [orderdate, setOrderdate] = useState("");
    const [orderTakenby, setOrdertakenby] = useState("");
    const [route, setroute] = useState("");


    const handleRouteTypeChange = async (selectedOption) => {
        setSelectedRoute(selectedOption);

        try {

            const response = await fetchData('RouteOutStandingAPI', `/${companyId}/${selectedOption.value}/${fromdate}/${toDate}`, token);
            if (response.responseCode === '1111') {
                const dataArray = response.response_data;

                dataArray.forEach(item => { });
                setData(dataArray);
                if (dataArray.length > 0) {
                    setcustomerid(response.response_data.Customerid);

                    setFilteredData(response.response_data.filter(item =>
                        (selectedOption ? item.route === selectedOption.value : true)
                    ));
                    console.log(response);
                }
            }
        } catch (error) {
            console.error('Error fetching Customer Details:', error);
        }
    };
    const getFirstDayOfMonth = () => {
        const today = new Date();
        return `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-01`;
    };

    const getCurrentDate = () => {
        const today = new Date();
        return `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
    };

    const handleFromDateChange = (e) => {
        setfromdate(e.target.value);
    };

    const handleToDateChange = (e) => {
        setToDate(e.target.value);
    };
    useEffect(() => {
        setfromdate(getFirstDayOfMonth());
        setToDate(getCurrentDate());
    }, []);



    const handleHistoryClick = async (customerid) => {
        try {
            const response = await fetchData('RouteOutStandingAPI', `/${companyId}/${customerid}`, token);

            // Log the response to see what it contains
            console.log('API response:', response);

            if (response.responseCode === '1111') {
                console.log('Customer Data:', response.response_data);  // Log customer data

                setSelectedCustomerData(response.response_data);  // Ensure this matches the state structure
                setShowModal(true);
            } else {
                console.error('Unexpected response code:', response.responseCode);
            }
        } catch (error) {
            console.error('Error fetching customer details:', error);
        }
    };
    const closeModal = () => {
        setSelectedCustomerData(null);  // Reset selected customer data when closing modal
        setShowModal(false);
    };

    const [showSearchInput, setShowSearchInput] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };
    //search
    const searchfilteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );
    // Handle Print

    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        printWindow.document.write('<html><head><title>Customer Outstanding Summary</title></head><body>');
        printWindow.document.write('<h3 style="font-family: Times New Roman; font-size: 32px;">Customer Outstanding Report</h3>');
        printWindow.document.write('<table style="border-collapse: collapse; width: 100%;">');
        printWindow.document.write('<thead style="background-color: #f3f3f3;">');
        printWindow.document.write('<tr>');

        // Updated Headers
        const headers = [
            'Sl.No', '', 'Customer Name', 'Invoice Date', 'Bill No.', 'Bill Amount',
            'Credit', 'Outstanding Amount', 'Amount 15-30 Days',
            'Amount 31-60 Days', 'Amount 61-90 Days', 'Amount > 90 Days'
        ];

        headers.forEach(header => {
            printWindow.document.write(`<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">${header}</th>`);
        });

        printWindow.document.write('</tr>');
        printWindow.document.write('</thead>');
        printWindow.document.write('<tbody>');

        let previousCustomerName = null;

        // Updated Data Loop
        data.forEach((rowData, index) => {
            printWindow.document.write('<tr>');
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;text-align: center">${index + 1}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.Total}</td>`);
            // Check if the current customer name is different from the previous one
            if (rowData.CustomerName !== previousCustomerName) {
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.CustomerName}</td>`);
                previousCustomerName = rowData.CustomerName; // Update previousCustomerName
            } else {
                printWindow.document.write('<td style="border: 1px solid #ddd; font-size: 16px;"></td>'); // Empty cell for repeated customer name
            }

            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.InvoiceDate ? new Date(rowData.InvoiceDate).toLocaleDateString('en-GB') : ''}</td>`);
            if (rowData.BillNumber) {
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.BillNumber}</td>`);

            } else {
                printWindow.document.write('<td style="border: 1px solid #ddd; font-size: 16px;"></td>'); // Empty cell for repeated customer name
            }
            //printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.BillNumber}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;text-align: right">${rowData.BillAmount.toFixed(2)}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;text-align: right">${rowData.PaidAmount.toFixed(2)}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;text-align: right">${rowData.BalanceAmount.toFixed(2)}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;text-align: right">${rowData.thirtyDays.toFixed(2)}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;text-align: right">${rowData.sixteeDays.toFixed(2)}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;text-align: right">${rowData.sixtoninteen.toFixed(2)}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;text-align: right">${rowData.Uptoninteen.toFixed(2)}</td>`);
            printWindow.document.write('</tr>');
        });

        printWindow.document.write('</tbody></table></body></html>');
        printWindow.document.close();
        printWindow.print();
    };


    //Excel 

    const handleExportExcel = () => {
        const excelData = [];
        const headerRow = [
            'Sl.No', '', 'Customer Name', 'Invoice Date', 'Bill No.', 'Bill Amount',
            'Credit', 'Outstanding Amount', 'Amount 15-30 Days',
            'Amount 31-60 Days', 'Amount 61-90 Days', 'Amount > 90 Days'
        ];
        excelData.push(headerRow);

        let previousCustomerName = null;

        // Add data rows
        data.forEach((rowData, index) => {
            const dataRow = [];

            dataRow.push(index + 1); // Sl.No
            dataRow.push(rowData.Total);
            // Check if the current customer name is different from the previous one
            if (rowData.CustomerName !== previousCustomerName) {
                dataRow.push(rowData.CustomerName); // Customer Name
                previousCustomerName = rowData.CustomerName; // Update previousCustomerName
            } else {
                dataRow.push(''); // Empty cell for repeated customer name
            }

            dataRow.push(rowData.InvoiceDate ? new Date(rowData.InvoiceDate).toLocaleDateString('en-GB') : ''); // Invoice Date
            dataRow.push(rowData.BillNumber); // Bill No.
            dataRow.push(rowData.BillAmount.toFixed(2)); // Bill Amount
            dataRow.push(rowData.PaidAmount.toFixed(2)); // Debit
            dataRow.push(rowData.BalanceAmount.toFixed(2)); // Outstanding Amount
            dataRow.push(rowData.thirtyDays.toFixed(2)); // Amount < 30 Days
            dataRow.push(rowData.sixteeDays.toFixed(2)); // Amount 31-60 Days
            dataRow.push(rowData.sixtoninteen.toFixed(2)); // Amount 61-90 Days
            dataRow.push(rowData.Uptoninteen.toFixed(2)); // Amount > 90 Days

            excelData.push(dataRow);
        });

        // Create worksheet
        const ws = XLSX.utils.aoa_to_sheet(excelData);

        // Create workbook
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Outstanding Report');

        // Save workbook to a file
        XLSX.writeFile(wb, 'Outstanding_Report.xlsx');
    };


    const getRowColor = (balanceQty, weight) => {
        if (balanceQty <= weight / 2) {
            return { backgroundColor: '#FFD0D0' };
        }
        else if (balanceQty <= weight / 3) {
            return { backgroundColor: '#FFFFE0' };
        }
        else {
            return {}; // Default style
        }
    };
    const handleRefreshClick = () => {

        // setToDate(getCurrentDate());
        // fetchData();
        window.location.reload();
    };
    const [page, setPage] = useState(0); // Current page
    const [rowsPerPage, setRowsPerPage] = useState(15); // Rows per page

    // Define initial column order
    const [columnOrder, setColumnOrder] = useState([

        'SL No',
        'Sales Executive',
        'Expense Date ',
        'Expense Type',
        'Expense Remark',
        'Odometer',
        'Amount',
        ''

    ]);
    // Process and paginate the data
    const processedData = searchfilteredData.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );


    // Handle page change
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    // Handle rows per page change
    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Reset to the first page
    };

    // Function to handle drag start
    const handleDragStart = (e, index) => {
        e.dataTransfer.setData('columnIndex', index);
    };

    // Function to handle drag over
    const handleDragOver = (e) => {
        e.preventDefault(); // Allow drop
    };
    // Function to handle drop
    const handleDrop = (e, index) => {
        const draggedIndex = e.dataTransfer.getData('columnIndex');
        if (draggedIndex !== index) {
            const newOrder = [...columnOrder];
            // Swap columns
            [newOrder[draggedIndex], newOrder[index]] = [newOrder[index], newOrder[draggedIndex]];
            setColumnOrder(newOrder);
        }
    };

    return (

        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '10px' }}>

            <div className='w-full mb-2 flex'>
                <h6
                    className="uppercase tracking-wide text-black flex-grow linkcolor"
                    style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
                    OUTSTANDING REPORT</h6>

                <div className="flex items-center space-x-6 justify-end mb-6" style={{ marginTop: '2px', gap: '10px' }}>
                    {/* Search Input */}
                    <div style={{ marginTop: '20px', gap: '10px' }}>
                        <input
                            className="shadow text-gray-700 leading-tight"
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                            onFocus={() => setIsFocused(true)}
                            onBlur={() => setIsFocused(false)}
                            style={{
                                width: isFocused ? '300px' : '200px',
                                height: '40px',
                                border: '1px solid #ccc',
                                borderRadius: '15px',
                                padding: '0 20px',
                                transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                                outline: 'none',
                                borderColor: isFocused ? 'darkcyan' : '#ccc',
                                boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                            }}
                        />
                    </div>

                    {/* From Date */}
                    <div className="flex flex-col space-y-1" >
                        <label className="block text-black text-sm " htmlFor="fromDate" style={{ fontSize: '14px' }}>
                            From Date
                        </label>
                        <input
                            aria-label="From:"
                            id="fromdate"
                            type="date"
                            className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                            value={fromdate}
                            onChange={handleFromDateChange}
                            style={{ width: '150px' }}
                        />
                    </div>

                    {/* To Date */}
                    <div className="flex flex-col space-y-1">
                        <label className="block text-black text-sm " htmlFor="toDate" style={{ fontSize: '14px' }}>
                            To Date
                        </label>
                        <input
                            aria-label="To:"
                            id="toDate"
                            type="date"
                            className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                            value={toDate}
                            onChange={handleToDateChange}
                            style={{ width: '150px' }}
                        />
                    </div>

                    {/* Route */}
                    {/* <div className="flex flex-col space-y-1" >
                        <label className="block text-black text-sm " htmlFor="salesmanSelect" style={{ fontSize: '14px' }}>
                            Route
                        </label>
                        <Select
                            value={selectedRoute}
                            onChange={handleRouteTypeChange}
                            options={[
                                { value: 0, label: "All Route" },
                                ...routeOptions
                            ]}
                            placeholder="Select Trip"
                            isSearchable
                            className="w-40"
                            styles={{
                                menu: (provided) => ({
                                    ...provided,
                                    zIndex: 1301, // Ensure dropdown appears above the sticky header
                                }),
                            }}
                        />
                    </div> */}
                   <div className="flex flex-col space-y-1" >
                        <Select
                            value={selectedRoute}
                            onChange={handleRouteTypeChange}
                            options={[
                                { value: 0, label: "All Route" },
                                ...routeOptions
                            ]}
                            placeholder="Select Trip"
                            isSearchable
                            className="w-40"
                            styles={{
                                menu: (provided) => ({
                                    ...provided,
                                    zIndex: 1301, // Ensure dropdown appears above the sticky header
                                }),
                            }}
                        />
                    </div>

                    {/* Buttons */}
                    <div className="flex space-x-2">

                        <Button
                            style={{
                                backgroundColor: '#C9E9D2',
                                color: 'black',
                                height: '36px',
                                marginTop: '2px',
                                marginLeft: '5px'

                            }}
                            onClick={handleRefreshClick}
                            className="linkcolor"
                        >
                            <span>Refresh</span>
                        </Button>

                        <Button
                            style={{
                                backgroundColor: '#F8E8EE',
                                color: 'black',
                                height: '36px',
                                marginTop: '2px',
                                marginLeft: '5px'

                            }}
                            onClick={handleExportExcel}
                            className="linkcolor"
                        >
                            <span>Excel</span>
                        </Button>
                        <Button
                            style={{
                                backgroundColor: '#E8F3D6',
                                color: 'black',
                                height: '36px',
                                marginTop: '2px',
                                marginLeft: '5px'

                            }}
                            onClick={handlePrint}
                            className="linkcolor"
                        >
                            <span>Print</span>
                        </Button>


                    </div>
                </div>


            </div>

            <div className='w-full mb-5 flex' style={{ maxHeight: '500px', overflowY: 'auto', marginTop: '5px' }}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{
                            backgroundColor: '#5F6F65', width: '100%', position: 'sticky', // Makes the header sticky
                            top: 0,             // Locks it to the top
                            zIndex: 1,
                        }}>
                            <TableRow>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'left' }}>Slno</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'left' }}></TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'left' }}>Customer Name</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'left' }}>Invoice Date</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'left' }}>Bill No.</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'right' }}>Bill Amount</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'right' }}>Credit</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'right' }}>Outstanding Amount</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'center' }}>Amt
                                    <span> 15-30 Days</span> </TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'center' }}>Amt
                                    <span> 31-60 Days</span> </TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'center' }}>Amt
                                    <span> 61-90 Days</span></TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'center' }}>Amt
                                    <span> {'>'} 90 Days</span></TableCell>

                            </TableRow>
                        </TableHead>
                        <TableBody >
                            {processedData.map((item, index) => {
                                const isFirstOccurrence = index === 0 || data[index - 1].CustomerName !== item.CustomerName;
                                const isGrandTotal = item.Total === 'GRAND TOTAL';
                                const isTotal = item.Total === 'TOTAL';

                                // Counter for customer entries
                                let customerCounter = 0;
                                if (!isTotal && !isGrandTotal) {
                                    customerCounter = data.slice(0, index).filter(i => i.total !== 'TOTAL' && i.total !== 'GRAND TOTAL').length;
                                }

                                return (
                                    <TableRow
                                        key={item.id}
                                        sx={{
                                            backgroundColor: isGrandTotal ? '#CADABF' : (isTotal ? '#FBF9F1' : 'transparent'),
                                            color: isGrandTotal ? 'darkred' : (isTotal ? 'blue' : 'black'),
                                            fontWeight: isGrandTotal || isTotal ? 'bold' : 'normal',
                                        }}
                                    >

                                        {!isTotal && !isGrandTotal && (
                                            <TableCell
                                                sx={{
                                                    borderBottom: '1px solid #F5F5F5',
                                                    color: 'black', // Default to black for regular rows
                                                    padding: '3px',
                                                    textAlign: 'left',
                                                }}
                                            >
                                                {customerCounter + 1}
                                            </TableCell>
                                        )}

                                        {/* TOTAL or GRAND TOTAL Label */}
                                        <TableCell
                                            colSpan={isTotal || isGrandTotal ? 2 : 1} // Adjust colspan for TOTAL and GRAND TOTAL rows
                                            sx={{
                                                borderBottom: '1px solid #F5F5F5',
                                                color: isGrandTotal ? 'darkred' : (isTotal ? 'blue' : 'black'),
                                                padding: '3px',
                                                textAlign: 'center',
                                            }}
                                        >
                                            {item.Total}
                                        </TableCell>

                                        {/* Customer Name */}
                                        <TableCell
                                            sx={{
                                                borderBottom: '1px solid #F5F5F5',
                                                color: isGrandTotal ? 'darkred' : (isTotal ? 'blue' : 'black'),
                                                padding: '3px',
                                                textAlign: 'left',
                                            }}
                                        >
                                            <a href="#" onClick={() => handleHistoryClick(item.Customerid)} className="tooltip-link">
                                                <h6
                                                    className="psheading linkcolor"
                                                    style={{
                                                        fontFamily: 'Times New Roman',
                                                        color: isGrandTotal ? 'darkred' : (isTotal ? 'blue' : 'black'),
                                                        cursor: 'pointer', fontSize: '16px'
                                                    }}
                                                >
                                                    {isFirstOccurrence ? item.CustomerName : ''}
                                                </h6>
                                            </a>
                                        </TableCell>

                                        {/* Invoice Date */}
                                        <TableCell
                                            sx={{
                                                borderBottom: '1px solid #F5F5F5',
                                                color: isGrandTotal ? 'darkred' : (isTotal ? 'blue' : 'black'),
                                                padding: '3px',
                                                textAlign: 'left',
                                            }}
                                        >
                                            {item.InvoiceDate ? new Date(item.InvoiceDate).toLocaleDateString('en-GB') : ''}
                                        </TableCell>

                                        {/* Bill No */}
                                        <TableCell
                                            sx={{
                                                borderBottom: '1px solid #F5F5F5',
                                                color: isGrandTotal ? 'darkred' : (isTotal ? 'blue' : 'black'),
                                                padding: '3px',
                                                textAlign: 'right',
                                            }}
                                        >
                                            {!isTotal && !isGrandTotal ? item.BillNumber : ''}
                                        </TableCell>

                                        {/* Bill Amount */}
                                        <TableCell
                                            sx={{
                                                borderBottom: '1px solid #F5F5F5',
                                                color: isGrandTotal ? 'darkred' : (isTotal ? 'blue' : 'black'),
                                                padding: '3px',
                                                textAlign: 'right',
                                            }}
                                        >
                                            {/* {item.BillAmount} */}
                                            {(item.BillAmount ?? 0).toFixed(2)}
                                        </TableCell>

                                        {/* Credit */}
                                        <TableCell
                                            sx={{
                                                borderBottom: '1px solid #F5F5F5',
                                                color: isGrandTotal ? 'darkred' : (isTotal ? 'blue' : 'black'),
                                                padding: '3px',
                                                textAlign: 'right',
                                            }}
                                        >
                                            {/* {item.PaidAmount} */}
                                            {(item.PaidAmount ?? 0).toFixed(2)}
                                        </TableCell>

                                        {/* Outstanding Amount */}
                                        <TableCell
                                            sx={{
                                                borderBottom: '1px solid #F5F5F5',
                                                color: isGrandTotal ? 'darkred' : (isTotal ? 'blue' : 'black'),
                                                padding: '3px',
                                                textAlign: 'right',
                                            }}
                                        >
                                            {/* {item.BalanceAmount} */}
                                            {(item.BalanceAmount ?? 0).toFixed(2)}
                                        </TableCell>
                                        <TableCell
                                            sx={{
                                                borderBottom: '1px solid #F5F5F5',
                                                color: isGrandTotal ? 'darkred' : (isTotal ? 'blue' : 'black'),
                                                padding: '3px',
                                                textAlign: 'right',
                                            }}
                                        >
                                            {/* {item.BalanceAmount} */}
                                            {(item.thirtyDays ?? 0).toFixed(2)}
                                        </TableCell>
                                        <TableCell
                                            sx={{
                                                borderBottom: '1px solid #F5F5F5',
                                                color: isGrandTotal ? 'darkred' : (isTotal ? 'blue' : 'black'),
                                                padding: '3px',
                                                textAlign: 'right',
                                            }}
                                        >
                                            {/* {item.BalanceAmount} */}
                                            {(item.sixteeDays ?? 0).toFixed(2)}
                                        </TableCell>
                                        <TableCell
                                            sx={{
                                                borderBottom: '1px solid #F5F5F5',
                                                color: isGrandTotal ? 'darkred' : (isTotal ? 'blue' : 'black'),
                                                padding: '3px',
                                                textAlign: 'right',
                                            }}
                                        >
                                            {/* {item.BalanceAmount} */}
                                            {(item.sixtoninteen ?? 0).toFixed(2)}
                                        </TableCell>
                                        <TableCell
                                            sx={{
                                                borderBottom: '1px solid #F5F5F5',
                                                color: isGrandTotal ? 'darkred' : (isTotal ? 'blue' : 'black'),
                                                padding: '3px',
                                                textAlign: 'right',
                                            }}
                                        >
                                            {/* {item.BalanceAmount} */}
                                            {(item.Uptoninteen ?? 0).toFixed(2)}
                                        </TableCell>

                                    </TableRow>
                                );
                            })}
                        </TableBody>
                        <TableFooter style={{ padding: '5px' }}>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[15, 25, 50, 100]}
                                    count={searchfilteredData.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handlePageChange}
                                    onRowsPerPageChange={handleRowsPerPageChange}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </TableContainer>

            </div >
            <Modal open={showModal} className={showModal ? 'notification-modal' : ''}>
                <div className="fixed inset-0 flex items-start justify-center z-10 ">
                    <div className="bg-green-100  p-6 rounded-lg shadow-lg" style={{ width: '1200px', maxHeight: '80vh', overflowY: 'auto', overflowX: 'auto' }}>
                        <div className="flex justify-end mt-2">
                            <button className="close-button md:static md:mr-2" onClick={closeModal} style={{ marginTop: '-20px', color: 'black' }}>
                                <Tooltip title="Close">
                                    <FaTimes />
                                </Tooltip>
                            </button>
                        </div>
                        <h4 style={{ fontFamily: 'Times New Roman', textAlign: 'center', color: 'teal', fontWeight: 'bolder' }}>Customer Details</h4>
                        <div className="used-items-container">
                            <TableContainer component={Paper} style={{ width: '100%', maxWidth: '1200px', margin: '0 auto' }}>
                                <table className="table" style={{ width: '100%' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ width: '5%', fontSize: '14px' }}>S.NO</th>
                                            <th style={{ width: '20%', fontSize: '14px' }}>Customer Name</th>
                                            <th style={{ width: '20%', fontSize: '14px' }}>Route</th>
                                            <th style={{ width: '10%', fontSize: '14px' }}>ContactNo.</th>
                                            <th style={{ width: '10%', fontSize: '14px' }}>ContactPerson  </th>
                                            <th style={{ width: '15%', fontSize: '14px' }}>Address</th>
                                            <th style={{ width: '15%', fontSize: '14px' }}>Location</th>
                                            <th style={{ width: '15%', fontSize: '14px' }}>PaymentMode </th>
                                            <th style={{ width: '15%', fontSize: '14px' }}>CustomerType </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {selectedCustomerData && selectedCustomerData.map((item, index) => (
                                            <tr key={index}>
                                                <td className="px-4 py-2 border-r" style={{ fontSize: '12px' }}>{index + 1}</td>
                                                <td className="px-4 py-2 border-r" style={{ fontSize: '12px' }}>{item.name}</td>
                                                <td className="px-4 py-2 border-r" style={{ fontSize: '12px' }}>{item.route}</td>
                                                <td className="px-4 py-2 border-r " style={{ fontSize: '13px' }}>{item.contactNumber1}</td>
                                                <td className="px-4 py-2 border-r " style={{ fontSize: '13px' }}>{item.contactPerson}</td>
                                                <td className="px-4 py-2 border-r " style={{ fontSize: '13px' }}>{item.addressLine1}</td>
                                                <td className="px-4 py-2 border-r " style={{ fontSize: '13px' }}>{item.district}</td>
                                                <td className="px-4 py-2 border-r " style={{ fontSize: '13px' }}>{item.paymentType}</td>
                                                <td className="px-4 py-2 border-r " style={{ fontSize: '13px' }}>{item.customerType}</td>

                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </TableContainer>

                        </div>
                    </div>
                </div>
            </Modal>

        </div >
    );
}

export default RouteWiseOutstandingReport;

